export default "__VITE_ASSET__D1EH4LCI__"